"use strict";

function ExamplePage() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;

  this.init = function () {};

  this.initAllReady = function () {
    this.analytics.pushEvent('virtual-page-view');
  };

  this.destroy = function () {
    console.log("Are you sure you've destroyed everything?");
  };
}